export default "__VITE_ASSET__BeCx2Mhr__"